import { makeStyles } from '@/styles/theme/tss-react';
import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'InputErrorText',
})(({ brandColors, type, typography: { pxToRem } }, props) => ({
  error: {
    color: darkOrLightStyle(props)(
      brandColors.semanticColorsError60,
      brandColors.semanticColorsError50
    ),
    ...type['14_medium'],
    display: 'flex',
    alignItems: 'center',
    gap: pxToRem(4),
    lineHeight: pxToRem(20),
    '& svg': {
      marginTop: pxToRem(2),
      color: darkOrLightStyle(props)(
        brandColors.semanticColorsError60,
        brandColors.semanticColorsError50
      ),
    },
  },
}));

export default useStyles;
